import { render, staticRenderFns } from "./failurePage.vue?vue&type=template&id=1fa72b48&scoped=true&"
import script from "./failurePage.vue?vue&type=script&lang=js&"
export * from "./failurePage.vue?vue&type=script&lang=js&"
import style0 from "./failurePage.vue?vue&type=style&index=0&id=1fa72b48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa72b48",
  null
  
)

export default component.exports